import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { BetslipPick } from 'packages/sports/common/betslip/core/picks/betslip-pick';
import { isBetBuilderPick } from 'packages/sports/common/betslip/core/utils';
import { RemoveButtonStyle } from 'packages/sports/common/betslip/modules/picks/components/digital/pick-remove-button/remove-button-style';
import { RemoveButtonPosition } from 'packages/sports/common/betslip/modules/single-bet/remove-button-position-enum';
import { LINEAR_CONTAINER_STAKE_SERVICE } from 'packages/sports/common/betslip/modules/stake/services/digital/linear/linear-container-stake.interface';
import { LINEAR_CONTAINER_SUMMARY_SERVICE } from 'packages/sports/common/betslip/modules/summary/services/linear/linear-container-summary.interface';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { NumpadService } from 'packages/sports/web/app/src/numpad/numpad.service';

import { BetslipType } from '../../../../../../core/betslip-type';
import { BetBuilderPick } from '../../../../../linear-bet-builder/models';
import { ComboBetContainerStakeService } from '../../../../services/combo-bet-container-stake.service';
import { ComboBetContainerSummaryService } from '../../../../services/combo-bet-container-summary.service';
import { LINEAR_COMBO_BET_CONTAINER_SERVICE_INJECTION_TOKEN } from '../../../../services/linear/linear-combo-bet-container-service.interface';
import { LinearMainComboContainerService } from '../../../../services/linear/linear-main-combo-bet-container.service';
import { IComboBetPickState, IComboBetState } from '../../../../state';

@Component({
    selector: 'bs-linear-main-combo-container',
    templateUrl: './linear-main-combo-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        NumpadService,
        { provide: LINEAR_COMBO_BET_CONTAINER_SERVICE_INJECTION_TOKEN, useClass: LinearMainComboContainerService },
        { provide: LINEAR_CONTAINER_SUMMARY_SERVICE, useClass: ComboBetContainerSummaryService },
        { provide: LINEAR_CONTAINER_STAKE_SERVICE, useClass: ComboBetContainerStakeService },
    ],
    standalone: false,
})
export default class LinearMainComboContainerComponent {
    @HostBinding('class.linear-main-container-checkboxes') readonly isCheckboxesEnabled: boolean;

    @Input() removeButtonPosition: RemoveButtonPosition;
    @Input() removeButtonStyle: RemoveButtonStyle;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() pickList: BetslipPick[];
    @Input() comboBetState: IComboBetState;
    betslipTypeCombo = BetslipType.Combo;

    readonly isEpcotEnabled: boolean;

    constructor(epcotConfig: EpcotConfigService, betslipConfig: BetslipConfig) {
        this.isEpcotEnabled = epcotConfig.isEnabled(EpcotModule.Betslip);
        this.isCheckboxesEnabled = betslipConfig.linearModeCheckboxesEnabled;
    }

    comboBetPick(pick: BetslipPick): IComboBetPickState {
        return this.comboBetState.picks[pick.id.toString()];
    }

    isBetBuilderPick(pick: BetslipPick): pick is BetBuilderPick {
        return isBetBuilderPick(pick);
    }
}
